itsoftApp.createModule("parallaxMouse", ["startLoad"], function() {
    var module = this;
    var libraries = {
        parallax: {
            name: "parallaxMouse",
            queue: [],
            started: false,
            loaded: false,
            script: "/assets/scripts/parallax/parallax.min.js"
        }
    }

    var initParallax = function (el) {
        if (el.classList.contains("scene--no-transition")) {
            el.classList.add("scene--active");
        }

        var parallax = new Parallax(el, {
            relativeInput: true,
            clipRelativeInput: true
        });
    }

    var init = function (el) {
        itsoftApp.modules.startLoad.callback(function () {
            initParallax(el);
        }, libraries.parallax);
    }

    module.callback = init;
});